import { render, staticRenderFns } from "./layout-aside.vue?vue&type=template&id=f703b4a4&scoped=true"
import script from "./layout-aside.vue?vue&type=script&lang=js"
export * from "./layout-aside.vue?vue&type=script&lang=js"
import style0 from "./layout-aside.vue?vue&type=style&index=0&id=f703b4a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f703b4a4",
  null
  
)

export default component.exports